/* eslint-disable react/no-danger */
/* eslint-disable react/jsx-props-no-spreading */
import { faCalendarAlt, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React, { useEffect, useLayoutEffect, useRef, useState } from "react";

import Calender from "./Calender";
import Portal from "./Portal";

function sanitizeDate(params) {
  let input = params;
  if (!/[a-zA-Z]/.test(params) && params.length === 10) {
    input = params.replace(/[\W_]+/g, "");
  }
  if (input.length === 8 && /^\d+$/.test(input)) {
    const sanitrizedInput = input.replaceAll("[^A-Za-z0-9]", "");
    const sanitizedDate = moment(sanitrizedInput, "DDMMYYYY").format("DD-MMM-YYYY");
    if (moment(sanitizedDate, "DD-MMM-YYYY", true).isValid()) {
      return sanitizedDate;
    }
  }
  return input;
}

export function DatePickerWithModal(props) {
  const { value, onChange, name, id, label, minDate, maxDate, disabled, ...rest } = props;
  const [val, setVal] = useState(value);
  const [showDropDown, setShowDropDown] = useState(false);
  const [focus, setfocus] = useState(false);
  const InputRef = useRef(null);
  const focusRef = useRef(null);
  const clearIconRef = useRef(null);
  useLayoutEffect(() => {
    if (focus && clearIconRef.current) {
      clearIconRef.current.focus();
    }
    setVal(value);
  }, [focus, value]);

  function handleOnChange(input) {
    const params = sanitizeDate(input);
    onChange(name, params);
    setVal(params);
    setShowDropDown(false);
  }
  function handleOnChangeCallback(params) {
    setfocus(true);
    handleOnChange(params);
  }
  function clearInputVal() {
    onChange(name, "");
    setVal("");
  }
  function onCloseHandler() {
    setShowDropDown(false);
    setTimeout(() => {
      clearIconRef.current.focus();
    }, 0);
  }
  function handleShiftKeyPress(event) {
    const isSpaceBarPressed = event.which === 32;
    if (isSpaceBarPressed) {
      setShowDropDown(true);
    } else {
      setShowDropDown(false);
    }
  }

  return (
    <div
      ref={InputRef}
      id={`container_${id}`}
      className={`custom-calendar-wrapper modal-calendar ${disabled ? "disabled" : ""}`}
    >
      <div className="dropdown input css-icon" aria-haspopup="true">
        <span className="invisible">{value}</span>
        <input
          onKeyPress={event => handleShiftKeyPress(event)}
          value={val}
          name={name}
          id={id}
          className={` ${disabled ? "disabled" : ""}`}
          {...rest}
          autoComplete="off"
          onChange={event => handleOnChange(event.target.value)}
          ref={focusRef}
        />

        <span className="icon-calendar">
          <button
            className={`fn-btn ${disabled ? "disabled" : ""}`}
            type="button"
            onClick={() => setShowDropDown(true)}
            title="Open Calendar"
          >
            <FontAwesomeIcon icon={faCalendarAlt} />
          </button>
          <button
            className={`fn-btn ${disabled ? "disabled" : ""}`}
            onClick={() => clearInputVal()}
            type="button"
            onFocus={() => setShowDropDown(false)}
            title="Clear date"
            ref={clearIconRef}
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </span>
      </div>
      {showDropDown && (
        <Portal
          rootId={`container_${id}`}
          modalTitle={label}
          className="calendar-modal custom-calendar-wrapper"
          onClose={() => onCloseHandler()}
          parent={InputRef.current}
        >
          <div style={{ zIndex: 999 }} className="dropdown-menu shadow-lg">
            <Calender handleOnChange={handleOnChangeCallback} value={value} minDate={minDate} maxDate={maxDate} />
          </div>
        </Portal>
      )}
    </div>
  );
}

export function DatePicker({
  value,
  onChange,
  name,
  id,
  maxDate,
  minDate,
  disabled = false,
  backgroundColor,
  containerClass,
  fixed,
  ...rest
}) {
  const [val, setVal] = useState(value);
  useEffect(() => {
    if (val !== value) {
      setVal(value);
    }
  }, [value, val, setVal]);

  const [showDropDown, setShowDropDown] = useState(false);
  const [valid, setValid] = useState(true);

  async function handleOnChange(input) {
    const params = sanitizeDate(input);
    if (params) {
      const checkValid = moment(params, "DD-MMM-YYYY", true).isValid();
      setValid(checkValid);
    } else {
      setValid(true);
    }
    await onChange(name, params, valid);
    setVal(params);
    setShowDropDown(false);
  }
  function onClear() {
    setVal("");
    onChange(name, "");
    setValid(true);
    setShowDropDown(false);
  }
  const handleBlur = e => {
    let { relatedTarget } = e;
    if (relatedTarget === null) {
      relatedTarget = document.activeElement;
    }
    if (!e.currentTarget.contains(relatedTarget)) {
      setShowDropDown(false);
    }
  };
  return (
    <div
      className={`custom-calendar-wrapper  ${
        disabled ? "disabled custom-calendar-wrapper-disabled bg-grey-disabled-light" : "bg-transprent"
      }`}
      onBlur={e => handleBlur(e)}
    >
      <div className="dropdown input">
        <span onFocus={() => !disabled && setShowDropDown(true)}>
          <input
            className="date-input"
            value={val}
            name={name}
            id={id}
            {...rest}
            autoComplete="off"
            disabled={disabled}
            tabIndex={disabled ? "-1" : ""}
            onChange={event => handleOnChange(event.target.value)}
          />
        </span>
        <span className="icon-calendar">
          <button
            tabIndex={disabled ? "-1" : ""}
            className="fn-btn"
            onFocus={() => !disabled && setShowDropDown(true)}
            type="button"
            title="Open Calendar"
          >
            <FontAwesomeIcon icon={faCalendarAlt} />
          </button>
          <button
            tabIndex={disabled ? "-1" : ""}
            className="fn-btn close"
            onClick={() => onClear()}
            type="button"
            title="Clear date"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </span>
      </div>
      {!valid && <div className=" col-7 mr-4 form-layout-message-error">Invalid Date</div>}
      {showDropDown && (
        <div
          className={`dropdown-menu shadow-lg ${fixed ? "fixed" : ""} ${containerClass}`}
          onBlur={e => handleBlur(e)}
        >
          <Calender handleOnChange={handleOnChange} value={value} minDate={minDate} maxDate={maxDate} />
        </div>
      )}
    </div>
  );
}
